import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const CheckoutFormSection = ({ data, onSubmit }: any) => {
    return (
        <div className="py-12 px-4 bg-gray-50">
            <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold mb-6 text-center">{data?.title || "Complete Your Order"}</h2>
                <div className="space-y-4">
                    <div>
                        <Label>Full Name</Label>
                        <Input placeholder="John Doe" />
                    </div>
                    <div>
                        <Label>Email</Label>
                        <Input type="email" placeholder="john@example.com" />
                    </div>
                    <div>
                        <Label>Phone</Label>
                        <Input type="tel" placeholder="+1234567890" />
                    </div>
                    <div>
                        <Label>Address</Label>
                        <Input placeholder="123 Main St" />
                    </div>
                    <Button className="w-full mt-4" size="lg" onClick={onSubmit}>
                        {data?.submitText || "Place Order"}
                    </Button>
                </div>
            </div>
        </div>
    );
};
